import type { IconProps } from "../../src/types";
import { splitProps } from "solid-js";

function renderSvg(kebab: string, props: IconProps) {
  const [local, rest] = splitProps(props, ["class", "size", "color", "strokeWidth"]);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={local.size ?? 24}
      height={local.size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke={local.color ?? "currentColor"}
      stroke-width={local.strokeWidth ?? 2}
      stroke-linecap="round"
      stroke-linejoin="round"
      class={local.class ? `lucide lucide-${kebab} ${local.class}` : `lucide lucide-${kebab}`}
      aria-hidden={rest["aria-label"] || rest.title ? undefined : "true"}
      {...rest}
    >
      <path d="M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z" />
      <path d="m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10" />
    </svg>
  );
}

export const MailOpen = (props: IconProps) => renderSvg("mail-open", props);
export const MailOpenIcon = MailOpen;
export default MailOpen;
